import { method } from 'lodash'
import axiosApi from './axiosApi'

export const getExamUserInfo = () => {
    return axiosApi({
        method: 'get',
        url: '/intserv/exam/getExamUserInfo',
    })
}

export const getExamRecord = () => {
    return axiosApi({
        method: 'get',
        url: '/intserv/exam/getExamRecord',
    })
}

export const findQuestionsByExamId = (data) => {
    return axiosApi({
        method: 'post',
        url: '/intserv/exam/findQuestionsByExamId',
        data
    })
}

export const getExam = (data) => {
    return axiosApi({
        method: 'post',
        url: '/intserv/exam/getExam',
        data
    })
}

export const submit = (data) => {
    return axiosApi({
        method: 'post',
        url: '/intserv/exam/submit',
        data
    })
}

export const checkExhausted = (examId) => {
    return axiosApi({
        method: 'get',
        url: `/intserv/exam/${examId}/attempts/check-exhausted`,
    })
}

export const getCertificateByStudent = () => {
    return axiosApi({
        method: 'get',
        url: `/intserv/exam/getCertificateByStudent`,
    })
}